import Inputmask from "inputmask";

// configurar currency como moeda brasileira

Inputmask.extendAliases({
  currency: {
    prefix: "R$ ",
    groupSeparator: ".",
    radixPoint: ",",
    digits: 2,
    digitsOptional: false,
  },
  decimal: {
    groupSeparator: ".",
    radixPoint: ",",
    digits: 2,
    autoGroup: true,
    digitsOptional: false,
  },
  cpf: {
    mask: "999.999.999-99",
    placeholder: "000.000.000-00",
    clearIncomplete: true,
  },
  cnpj: {
    mask: "99.999.999/9999-99",
    placeholder: "00.000.000/0000-00",
    clearIncomplete: true,
  },
  cartao_sus: {
    mask: "999 999 999 999 999",
    placeholder: "000 000 000 000 000",
    clearIncomplete: true,
  },
  telefone: {
    mask: "(99) 99999-9999",
    placeholder: "(00) 00000-0000",
    clearIncomplete: true,
  },
  celular: {
    mask: "(99) 99999-9999",
    placeholder: "(00) 00000-0000",
    clearIncomplete: true,
  },
  cep: {
    mask: "99999-999",
    placeholder: "00000-000",
    clearIncomplete: true,
  },
});

export default Inputmask;
